import { render, staticRenderFns } from "./CreateInvoiceModal.vue?vue&type=template&id=12887f1c"
import script from "./CreateInvoiceModal.vue?vue&type=script&lang=js"
export * from "./CreateInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./CreateInvoiceModal.vue?vue&type=style&index=0&id=12887f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports